import { createFileRoute } from "@tanstack/react-router";

import { PageEyeBrow } from "#/components/PageEyeBrow";
import { PageHeader } from "#/components/PageHeader";
import { PageIntro } from "#/components/PageIntro";
import { DOCUMENT_TITLES, documentHead } from "#/lib/documentTitle";
import { globalStatsQueryOptions } from "#/lib/queries";
import { loadGlobalStats } from "#/server/game/globalStats";

import { GlobalStatsSection } from "./-index.globalStats";
import { UnitStatsChart } from "./-stats.unitChart";

export const Route = createFileRoute("/stats")({
  head: () => documentHead(DOCUMENT_TITLES.stats),
  loader: async ({ context }) => {
    const stats = await loadGlobalStats();
    context.queryClient.setQueryData(globalStatsQueryOptions().queryKey, stats);
    return stats;
  },
  component: StatsPage,
});

function StatsPage() {
  const stats = Route.useLoaderData();

  return (
    <main className="mx-auto w-full max-w-[1080px] px-4 py-10">
      <div className="mx-auto flex w-full max-w-3xl flex-col gap-6">
        <PageIntro>
          <PageEyeBrow>Across all players</PageEyeBrow>
          <PageHeader>Global stats</PageHeader>
        </PageIntro>
        <GlobalStatsSection />
        <UnitStatsChart
          title="Units built"
          record={stats.unitsBuiltByKind}
          metric="built"
          player="p1"
        />
        <UnitStatsChart
          title="Units killed"
          record={stats.unitsKilledByKind}
          metric="killed"
          player="p2"
          hideTransports
        />
      </div>
    </main>
  );
}
